import { GET, POST } from './utils';

// eslint-disable-next-line no-undef
const getAPIURL = (path) => `${process.env.REACT_APP_API_URL}/${path}`;

export const GET_EMPLOYMENT_VERIFICATION = ({ token }) =>
  GET({ raw_url: getAPIURL(`employment-verification/${token}`), autoLogOut: false });

export const SUBMIT_EMPLOYMENT_VERIFICATION = ({ token, data }) =>
  POST({ raw_url: getAPIURL(`employment-verification/${token}/submit`), data, autoLogOut: false });
